import { usePageTitleTranslation } from 'libs/navigation';

import { useOperations } from '../hooks/useOperations';
import { OperationsView } from '../views/OperationsView';

export const OperationsContainer = () => {
  const {
    operations,
    loading,
    rowCount,
    limit,
    page,
    sort,
    filter,
    setFilter,
    brokerTimezoneOffset,
    onSortChange,
    onPaginationChange,
    setRowHref,
  } = useOperations();

  usePageTitleTranslation('operation.operations.title');

  return (
    <OperationsView
      brokerTimezoneOffset={brokerTimezoneOffset}
      filter={filter}
      limit={limit}
      loading={loading}
      operations={operations}
      page={page}
      rowCount={rowCount}
      setFilter={setFilter}
      setRowHref={setRowHref}
      sort={sort}
      onPaginationChange={onPaginationChange}
      onSortChange={onSortChange}
    />
  );
};
